
define('text!templates/widgets/audio/audioPlayerSetup.html',[],function () { return '<div data-bind="foreach: audioChannels">\n    <div class="audio-elements">\n        <audio preload="auto">\n        </audio>\n    </div>\n</div>\n';});

